import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { Field, Form, reduxForm } from 'redux-form';
import { propFunc, propShape, propStr, ReduxFormProps, } from '../../../../../../../helpers/custom-prop-types';
import { compose } from '../../../../../../../helpers/recompose';
import { validateFolder } from '../../../../../../../validate/custom/slide_search/folder';
import FolderNameFormText from './FolderNameFormText';
const FolderNameFormInner = (props) => {
    const { fieldClassName, formClassName, handleSubmit, inputRef, placeholder, submit, submitting, } = props;
    return (_jsx(Form, Object.assign({ className: clsx('proffit_search_folder_name_form', formClassName), onSubmit: handleSubmit }, { children: _jsx(Field, { className: fieldClassName, component: FolderNameFormText, disabled: submitting, inputRef: inputRef, name: 'name', placeholder: placeholder, validate: validateFolder.name, wrapOnBlur: submit }) })));
};
FolderNameFormInner.propTypes = Object.assign({ fieldClassName: propStr().isRequired, formClassName: propStr().isRequired, inputRef: propShape().isRequired, placeholder: propStr().isRequired }, ReduxFormProps);
const FolderNameForm = compose(reduxForm())(FolderNameFormInner);
FolderNameForm.propTypes = {
    fieldClassName: propStr().isRequired,
    formClassName: propStr().isRequired,
    initialValues: propShape().isRequired,
    inputRef: propShape().isRequired,
    onSubmit: propFunc().isRequired,
    placeholder: propStr().isRequired,
};
export default FolderNameForm;
